import { Stack, Typography, useMediaQuery } from '@mui/material';
import EmptyLanguageIllustration from './empty-language-illustration.svg';

const EmptyView = () => {
   const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('md')); // Adjust breakpoint as needed
    return (
        <Stack p={3} gap={3} justifyContent={'center'} alignItems={'center'}>
            <img src={EmptyLanguageIllustration} alt="Aucune expérience trouvée" />
            <Stack maxWidth={500} gap={1}>
                <Typography textAlign="center">
                    Vous n'avez pas encore saisi de compétences linguistiques
                </Typography>
                <Typography textAlign="center" color="textSecondary" fontSize={isMobile ? 12 : 16}>
                     Démarquez-vous en ajoutant des langues à votre profil et rendez votre profil plus visible.
                </Typography>
            </Stack>
        </Stack>
    );
};

export default EmptyView;
